export default "__VITE_PUBLIC_ASSET__ef4044d4__"